import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
// css
import styles from "./MealsPop.module.scss";
import { priceCurrency } from "../../../helpers/common";
import { useSaveIngredientsMutation } from "../../../store/services/orderService";
import { MdDelete } from "react-icons/md";

const OrderMealDetail = ({ title, modalOpen, setModalOpen, meal }) => {
  console.log("meal", meal);
  // const [saveIngredients, { isLoading: isUpdating }] = usesaveIngredientsMutation();
  const [ingredients, setIngredients] = useState(
    meal?.ingredients.map((ingredient) => ({ ...ingredient })) || []
  );
  console.log("ingredientsPOP==>", ingredients);
  const [saveIngredients, { isLoading: isUpdating }] = useSaveIngredientsMutation();

  const [newIngredients, setNewIngredients] = useState([]);
  const handleNewIngredientChange = (e, index, field) => {
    const updatedNewIngredients = [...newIngredients];
    updatedNewIngredients[index][field] = e.target.value;
    setNewIngredients(updatedNewIngredients);
  };

  // const handleAddIngredient = () => {
  //   setNewIngredients([...newIngredients, { name: "", quantity: "", unit: "", cooked_state: "", added:true }]);
  // };

  const handleAddIngredient = () => {
    setNewIngredients(prevNewIngredients => [
      ...prevNewIngredients.map(ingredient => ({ ...ingredient, added: true })), // Keep previous ones as added
      { name: "", quantity: "", unit: "", cooked_state: "", adjustedQuantity: 0, added: true } // Add new one
    ]);
  };
  

  // const handleRemoveIngredient = (index, isExisting) => {
  //   if (isExisting) {
  //     setIngredients(ingredients.filter((_, i) => i !== index));
  //   } else {
  //     setNewIngredients(newIngredients.filter((_, i) => i !== index));
  //   }
  // };

  const handleRemoveIngredient = (index, isNew) => {
    if (isNew) {
      setNewIngredients(newIngredients.filter((_, i) => i !== index));
    } else {
      setIngredients(ingredients.filter((ingredient, i) => !(i === index && ingredient.added)));
    }
  };


  const handleAdjustedQuantityChange = (e, index) => {
    const updatedIngredients = ingredients.map((ingredient, i) =>
      i === index ? { ...ingredient, adjustedQuantity: e.target.value } : ingredient
    );
    setIngredients(updatedIngredients);
  };

  // const handleSave = async () => {
  //   const payload = {
  //     mealId: meal._id,
  //     ingredients: ingredients.map((ingredient) => ({
  //       _id: ingredient._id,
  //       //adjustedQuantity: ingredient.adjustedQuantity,
  //       adjustedQuantity: Number(ingredient.adjustedQuantity),
  //     })),
  //   };

  //   try {
  //     await saveIngredients(payload).unwrap();
  //     // alert("Ingredients saved successfully!");
  //   } catch (error) {
  //     console.error("Failed to save ingredients:", error);
  //    // alert("Failed to save. Please try again.");
  //   }
  // };

  // const handleSave = async () => {
  //   const payload = {
  //     mealId: meal._id,
  //     ingredients: [
  //       ...ingredients.map(ingredient => ({
  //         _id: ingredient._id,
  //         adjustedQuantity: Number(ingredient.adjustedQuantity),
  //       })),
  //       ...newIngredients.filter(ing => ing.name && ing.quantity && ing.unit), // Only save filled fields
  //     ],
  //   };

  //   try {
  //     await saveIngredients(payload).unwrap();
  //     setNewIngredients([]); // Clear new ingredients after saving
  //   } catch (error) {
  //     console.error("Failed to save ingredients:", error);
  //   }
  // };


  // const handleSave = async () => {
  //   const newValidIngredients = newIngredients.filter(ing => ing.name && ing.quantity && ing.unit);

  //   const payload = {
  //     mealId: meal._id,
  //     ingredients: [
  //       ...ingredients.map(ingredient => ({
  //         _id: ingredient._id,
  //         name: ingredient.name,
  //         quantity: ingredient.quantity,
  //         unit: ingredient.unit,
  //         cooked_state: ingredient.cooked_state,
  //         adjustedQuantity: Number(ingredient.adjustedQuantity),
  //       })),
  //       ...newValidIngredients,
  //     ],
  //   };

  //   try {
  //     const response = await saveIngredients(payload).unwrap();

  //     // Merge new ingredients with existing ones
  //     setIngredients(prevIngredients => [
  //       ...prevIngredients,
  //       ...newValidIngredients
  //     ]);

  //     setNewIngredients([]); // Clear the input fields after save
  //   } catch (error) {
  //     console.error("Failed to save ingredients:", error);
  //   }
  // };




  const handleSave = async () => {
    const newValidIngredients = newIngredients
      .filter(ing => ing.name && ing.quantity && ing.unit)
      .map(ing => ({
        ...ing,
        nutritionalInfo: ing.nutritionalInfo || { carbs: 0, fat: 0, protein: 0 },
      }));

    const payload = {
      mealId: meal._id,
      ingredients: [
        ...ingredients.map(ingredient => ({
          _id: ingredient._id,
          name: ingredient.name,
          quantity: ingredient.quantity,
          unit: ingredient.unit,
          cooked_state: ingredient.cooked_state,
          adjustedQuantity: Number(ingredient.adjustedQuantity),
          nutritionalInfo: ingredient.nutritionalInfo || { carbs: 0, fat: 0, protein: 0 },
          added: ingredient?.added || false
        })),
        ...newValidIngredients,
      ],
    };

    try {
      const response = await saveIngredients(payload).unwrap();

      // Merge old and new ingredients, ensuring nutritionalInfo is preserved
      setIngredients(prevIngredients => [
        ...prevIngredients.map(ingredient => ({
          ...ingredient,
          nutritionalInfo: ingredient.nutritionalInfo || { carbs: 0, fat: 0, protein: 0 },
        })),
        ...newValidIngredients,
      ]);

      setNewIngredients([]); // Clear new ingredients after saving
    } catch (error) {
      console.error("Failed to save ingredients:", error);
    }
  };


  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.MealsPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Row>
            <Col xs={6} className="meal-image text-center my-3">
              <img
                src={meal?.image}
                alt="Grilled Tofu with Quinoa"
                className="img-fluid rounded w-100"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Col>
            {/* <Col xs={6} className="meal-info align-self-center">
              <p>
                <strong>Meal Type:</strong> {meal?.mealType}
              </p>
              <p>
                <strong>Price:</strong> {priceCurrency(meal?.price)}
              </p>
            </Col> */}

            <Col xs={6} className="macros my-3">
              {/* <h4 className="fw-bold">Nutritional Information:</h4> */}
              <ul className="list-group">
                <li className="list-group-item">
                  <strong>Calories:</strong> {meal?.macros?.calories} kcal
                </li>
                <li className="list-group-item">
                  <strong>Carbs:</strong> {meal?.macros?.carbs}g
                </li>
                <li className="list-group-item">
                  <strong>Protein:</strong> {meal?.macros?.protein}g
                </li>
                <li className="list-group-item">
                  <strong>Fat:</strong> {meal?.macros?.fat}g
                </li>
                <li className="list-group-item text-uppercase">
                  <strong>Status:</strong> {meal?.status}
                </li>
              </ul>
            </Col>

            {/* <Col xs={12} className="ingredients my-3">
              <h4 className="fw-bold">Ingredients:</h4>
              <ul className="list-group">
                {ingredients.map((ingredient, index) => (
                  <li key={ingredient._id} className="list-group-item  d-flex align-items-center justify-content-between">
                    {ingredient.name}: {ingredient.quantity}
                    {ingredient.unit} (Carbs: {ingredient.nutritionalInfo.carbs}g, Protein: {ingredient.nutritionalInfo.protein}g, Fat: {ingredient.nutritionalInfo.fat}g), ({ingredient.cooked_state})
                    <input
                      type="number"
                      placeholder="Enter adjust quantity"
                      value={ingredient.adjustedQuantity || ""}
                      onChange={(e) => handleAdjustedQuantityChange(e, index)}
                      className="ms-2"
                      style={{
                        width: "180px",
                        border: "1px solid #aaa",
                        borderRadius: "4px",
                        padding: "4px",
                      }}
                    />
                  </li>
                ))}
              </ul>
              <div className="d-flex justify-content-end mt-3">
                <button
                  //className="btn btn-success mt-3"
                  className="d-inline-flex align-items-center justify-content-center commonBtn btn btn-primary"
                  onClick={handleSave}
                  disabled={isUpdating}
                >
                  {isUpdating ? "Saving..." : "Save"}
                </button>
              </div>
            </Col> */}


            <Col xs={12} className="ingredients my-3">
              <h4 className="fw-bold">Ingredients:</h4>
              <ul className="list-group">
                {ingredients.map((ingredient, index) => (
                  <li key={ingredient._id} className="list-group-item d-flex align-items-center justify-content-between">
                    {ingredient.name}: {ingredient.quantity} {ingredient.unit}
                    (Carbs: {ingredient.nutritionalInfo?.carbs}g, Protein: {ingredient.nutritionalInfo?.protein}g, Fat: {ingredient.nutritionalInfo?.fat}g), ({ingredient.cooked_state})
                    <input
                      type="number"
                      placeholder="Enter adjust quantity"
                      value={ingredient.adjustedQuantity || ""}
                      onChange={(e) => handleAdjustedQuantityChange(e, index)}
                      className="ms-2"
                      style={{
                        width: "180px",
                        border: "1px solid #aaa",
                        borderRadius: "4px",
                        padding: "4px",
                      }}
                    />
                    {ingredient.added && (
                      <button className="btn btn-danger" onClick={() => handleRemoveIngredient(index, false)}>
                       {/* <MdDelete /> */} Remove
                      </button>
                    )}

                  </li>
                ))}
              </ul>
              {newIngredients.map((newIngredient, index) => (
                <div key={index} className="list-group-item d-flex align-items-center justify-content-between mt-2">
                  <input
                    type="text"
                    placeholder="Ingredient Name"
                    value={newIngredient.name}
                    onChange={(e) => handleNewIngredientChange(e, index, 'name')}
                    className="form-control me-2"
                  />
                  <input
                    type="number"
                    placeholder="Quantity"
                    value={newIngredient.quantity}
                    onChange={(e) => handleNewIngredientChange(e, index, 'quantity')}
                    className="form-control me-2"
                  />
                  <input
                    type="text"
                    placeholder="Unit"
                    value={newIngredient.unit}
                    onChange={(e) => handleNewIngredientChange(e, index, 'unit')}
                    className="form-control me-2"
                  />
                  <select
                    value={newIngredient.cooked_state || ""}
                    onChange={(e) => handleNewIngredientChange(e, index, 'cooked_state')}
                    //className="form-select me-2"
                    className="form-control"
                  >
                    <option value="">Select State</option>
                    <option value="cooked">Cooked</option>
                    <option value="uncooked">Uncooked</option>
                  </select>

                  {/* <button className="btn btn-danger ms-2" onClick={() => handleRemoveIngredient(index, true)}><MdDelete /></button> */}


                </div>
              ))}
              <div className="d-flex justify-content-between mt-3">
                <button
                  // className="btn btn-secondary"
                  className="d-inline-flex align-items-center justify-content-center commonBtn btn btn-primary"
                  onClick={handleAddIngredient}
                >
                  Add More
                </button>
                <button
                  className="d-inline-flex align-items-center justify-content-center commonBtn btn btn-primary"
                  onClick={handleSave}
                  disabled={isUpdating}
                >
                  {isUpdating ? "Saving..." : "Save"}
                </button>
              </div>
            </Col>




            <Col xs={12} className="recipe my-3">
              <h4 className="fw-bold">Recipe:</h4>
              <ol className="list-group list-group-numbered">
                {meal?.cookingInstructions?.length > 0 &&
                  meal?.cookingInstructions?.map((item, index) => (
                    <li className="list-group-item" key={index}>
                      {item}
                    </li>
                  ))}
              </ol>
            </Col>

            {/* <Col xs={12} className="cooking-instructions my-3">
              <h4 className="fw-bold">Cooking Instructions:</h4>
              <ol className="list-group list-group-numbered">
                {meal?.cookingInstructions?.map((item, index) => (
                  <li className="list-group-item" key={index}>
                    {item}
                  </li>
                ))}
              </ol>
            </Col> */}
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OrderMealDetail;
